var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"link-arrow-left",attrs:{"to":_vm.href}},[_c('img',{attrs:{"src":_vm.srcSelect + '#icon-next-' + this.theme,"width":"8","height":"14"}}),_vm._v("\n    "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }